import { defineMessage } from '@lingui/core/macro';
import { UnitJsonConfig } from '@/core/types/battle.types';

export const varangian: UnitJsonConfig = {
    id: 'varangian',
    unitName: defineMessage({ message: 'Varangian' }),
    stats: {
        hp: 90,
        stamina: 120,
        speed: 4,
        armor: 25,
        evasion: 15,
        meleeSkill: 95,
        armorPenetration: 0.45,
        critChance: 15,
        critMult: 1.3,
        initiative: 42,
        damageMin: 19,
        damageMax: 25,
    },
    skills: [
        {
        id: 'r_a_axe',
        name: defineMessage({ message: 'Axe Stroke' }),
        sort: 10,
        cost: 50,
        range: 1,
        hitChanceBonus: 5,
        critChanceBonus: 5,
        iconRow: 2,
        iconCol: 0,
    },
    ],
    anchor: {
        x: 0.5,
        y: 0.65,
    },
    badge: {
        x: 75,
        y: -190,
    },
    unitPortrait: {
        row: 0,
        col: 3,
    },
} satisfies UnitJsonConfig;
